"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputNumber = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const InputNumber = (props) => {
    const defaultProps = {
        decimalSeparator: ',',
    };
    return (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { ...defaultProps, ...props });
};
exports.InputNumber = InputNumber;
